import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.class.homeworkdetails;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SEARCH_STUDENT_ASYNC: `${uid}.searchStudentAsync`,
    SEARCH_STUDENT_SUCCESS: `${uid}.searchStudentSuccess`,
    SEARCH_STUDENT_FAILURE: `${uid}.searchStudentFailure`,
    ADD_OR_DELETE_CHECK: `${uid}.addOrDeleteCheck`,
    ADD_ALL_CHECK: `${uid}.addAllCheck`,
    DELETE_ALL_CHECK: `${uid}.deleteAllCheck`,
    SEND_REMINDER_ASYNC: `${uid}.sendReminderAsync`,
    SEND_REMINDER_SUCCESS: `${uid}.sendReminderSuccess`,
    SEND_REMINDER_FAILURE: `${uid}.sendReminderFailure`,
};

export { ActionTypes };
